/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Parameters for generating one scheduled oral-exam question update.
 */
export interface ScheduledChangeGenerateParams {
  changeId: string;
}
